export type AutoRefreshIntervalUnit = 'minutes' | 'hours';

/** Mirrors MAX_AUTO_REFRESH_INTERVAL_MINUTES on the COMS side (one week). */
export const MAX_AUTO_REFRESH_INTERVAL_MINUTES = 7 * 24 * 60;

export function maxIntervalAmountForUnit(
  unit: AutoRefreshIntervalUnit
): number {
  return unit === 'hours'
    ? MAX_AUTO_REFRESH_INTERVAL_MINUTES / 60
    : MAX_AUTO_REFRESH_INTERVAL_MINUTES;
}

/** Whole minutes in [1, max], or null when the input cannot be saved. */
export function validIntervalMinutes(
  amount: number,
  unit: AutoRefreshIntervalUnit
): number | null {
  const minutes = intervalToMinutes(amount, unit);
  if (!Number.isInteger(minutes) || minutes < 1) return null;
  if (minutes > MAX_AUTO_REFRESH_INTERVAL_MINUTES) return null;
  return minutes;
}

export function intervalToMinutes(
  amount: number,
  unit: AutoRefreshIntervalUnit
): number {
  if (!Number.isFinite(amount) || amount <= 0) return 0;
  return unit === 'hours' ? Math.round(amount * 60) : Math.round(amount);
}

export function minutesToInterval(minutes: number): {
  amount: number;
  unit: AutoRefreshIntervalUnit;
} {
  if (minutes >= 60 && minutes % 60 === 0) {
    return { amount: minutes / 60, unit: 'hours' };
  }
  return { amount: minutes > 0 ? minutes : 1, unit: 'minutes' };
}
